import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { BrowserStorageConsentProvider } from "./context/browser-storage-consent-context";
import { DisciplioProvider } from "./context/disciplio-context";
import { AiConsentProvider } from "./context/ai-consent-context";
import { CompletionConfirmationProvider } from "./context/completion-confirmation-context";
import { I18nProvider } from "./context/i18n-context";
import { OnboardingProvider } from "./context/onboarding-context";
import { AppRecoveryBoundary } from "./components/AppRecoveryBoundary";
import { BrowserStorageConsentBanner } from "./components/BrowserStorageConsentBanner";
import { AnalyticsBridge } from "./analytics/AnalyticsBridge";
import { App } from "./App";
import { capturePasswordResetToken } from "./password-reset-token";
import { initSentry } from "./observability/sentry";
import "@daypicker/react/style.css";
import "./index.css";

initSentry();
capturePasswordResetToken();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserStorageConsentProvider>
      <I18nProvider>
        <BrowserRouter>
          <DisciplioProvider>
            <AnalyticsBridge />
            <CompletionConfirmationProvider>
              <OnboardingProvider>
                <AiConsentProvider>
                  <AppRecoveryBoundary>
                    <App />
                    <BrowserStorageConsentBanner />
                  </AppRecoveryBoundary>
                </AiConsentProvider>
              </OnboardingProvider>
            </CompletionConfirmationProvider>
          </DisciplioProvider>
        </BrowserRouter>
      </I18nProvider>
    </BrowserStorageConsentProvider>
  </StrictMode>
);
